import { Link } from "react-router-dom";
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import { nailists } from "../../mocks/nailists";

const ABOUT_IMAGE = "https://public.readdy.ai/ai/img_res/2dfa91aeb4d4ae09c03a7443413e8b5c.jpg";
const CONCEPT_IMAGE = "https://readdy.ai/api/search-image?query=elegant%20nail%20technician%20Japanese%20woman%20carefully%20working%20on%20client%20nails%2C%20professional%20nail%20salon%20setting%2C%20warm%20lighting%2C%20rose%20gold%20tools%2C%20beige%20and%20white%20decor%2C%20luxury%20beauty%20service%20photography%2C%20refined%20atmosphere&width=800&height=600&seq=about2&orientation=landscape";

const faqs = [
  { q: "初めてでも大丈夫ですか？", a: "もちろんです。初めての方も丁寧にカウンセリングし、ご希望に合ったデザインをご提案いたします。" },
  { q: "予約なしでも来店できますか？", a: "できる限り事前のご予約をお願いしております。当日空きがあればご対応いたします。お電話にてご確認ください。" },
  { q: "ジェルネイルを初めてやりたいのですが？", a: "初めての方も安心してお任せください。爪の状態を確認し、長持ちするジェルネイルをご提案します。" },
  { q: "どれくらいで取れますか？", a: "施術内容やお客様の生活スタイルによりますが、通常3〜4週間程度は綺麗な状態を保てます。" },
  { q: "子ども連れでも来られますか？", a: "施術に集中するためサロン内は静かな環境を保っております。小さなお子様連れはご遠慮いただいております。" },
];

export default function AboutPage() {
  return (
    <div>
      <Navbar />

      {/* Hero */}
      <section className="relative pt-40 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img src={ABOUT_IMAGE} alt="BE:NAIL サロン" className="w-full h-full object-cover object-top" />
          <div className="absolute inset-0 bg-black/50" />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 text-center">
          <p className="text-[#C9A86A] text-xs tracking-[0.3em] uppercase mb-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>About Us</p>
          <h1 className="text-4xl lg:text-5xl text-white mb-4" style={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 300 }}>
            BE:NAILについて
          </h1>
          <p className="text-white/75 text-sm max-w-md mx-auto" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
            上質な体験と確かな技術で、あなたの美しさをサポートします
          </p>
        </div>
      </section>

      {/* Concept */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="text-[#B8956A] text-xs tracking-[0.3em] uppercase mb-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>Our Concept</p>
              <h2 className="text-3xl text-[#3D2E2A] mb-6" style={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 300 }}>
                大人の女性のための<br />ネイル体験
              </h2>
              <div className="space-y-4 text-[#6B5548] text-sm leading-relaxed" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                <p>BE:NAILは、40代の女性が心から楽しめる上質なネイルサロンです。日常の忙しさを忘れ、自分だけの贅沢な時間を過ごしていただけるよう、サロン全体にこだわりの空間をご用意しています。</p>
                <p>経験豊富なネイリストが、お客様おひとりおひとりの爪の状態やライフスタイルに合わせた施術をご提案します。トレンドを押さえながらも、長く愛せる上品なデザインが私たちの得意とするところです。</p>
                <p>御堂筋線XX駅から徒歩5分のアクセスしやすい立地で、仕事帰りや休日のお出かけのついでにも気軽にお立ち寄りいただけます。</p>
              </div>
            </div>
            <div className="rounded-2xl overflow-hidden border border-[#EDE7DF] h-[400px]">
              <img src={CONCEPT_IMAGE} alt="施術風景" className="w-full h-full object-cover object-top" />
            </div>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="py-20 bg-[#FAF8F6]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-12">
            <p className="text-[#B8956A] text-xs tracking-[0.3em] uppercase mb-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>Our Values</p>
            <h2 className="text-3xl text-[#3D2E2A]" style={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 300 }}>BE:NAILの3つのこだわり</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              { icon: "ri-heart-2-line", title: "丁寧なカウンセリング", desc: "施術前のカウンセリングを大切にしています。爪の状態・お仕事・生活スタイルを伺い、最適なデザインと施術をご提案します。" },
              { icon: "ri-shield-check-line", title: "爪に優しい施術", desc: "爪への負担を最小限に抑えるやさしい施術方法を採用。長くきれいな爪を保つためのアフターケアのアドバイスも行います。" },
              { icon: "ri-sparkling-2-line", title: "上質な空間・素材", desc: "厳選した高品質なジェルやケア用品のみを使用。サロン内は清潔感とやすらぎを大切にした空間でお客様をお迎えします。" },
            ].map(({ icon, title, desc }) => (
              <div key={title} className="bg-white rounded-xl p-8 border border-[#EDE7DF] text-center">
                <div className="w-14 h-14 flex items-center justify-center mx-auto mb-5 rounded-full bg-[#F2E8DF]">
                  <i className={`${icon} text-[#B8956A] text-xl`} />
                </div>
                <h3 className="text-[#3D2E2A] text-lg mb-3" style={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 500 }}>{title}</h3>
                <p className="text-[#8B7355] text-sm leading-relaxed" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-14">
            <p className="text-[#B8956A] text-xs tracking-[0.3em] uppercase mb-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>Our Team</p>
            <h2 className="text-3xl text-[#3D2E2A]" style={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 300 }}>スタッフ紹介</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {nailists.map((n) => (
              <div key={n.id} className="text-center border border-[#EDE7DF] rounded-2xl overflow-hidden">
                <div className="w-full h-72 overflow-hidden">
                  <img src={n.image} alt={n.name} className="w-full h-full object-cover object-top" />
                </div>
                <div className="p-6">
                  <h3 className="text-[#3D2E2A] text-xl mb-1" style={{ fontFamily: "'Noto Serif JP', serif" }}>{n.name}</h3>
                  <p className="text-[#B8956A] text-xs mb-3" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>ネイル歴{n.years}年 / {n.specialty}</p>
                  <p className="text-[#6B5548] text-xs leading-relaxed" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>{n.description}</p>
                  <Link to={`/booking?nailist=${n.id}`} className="mt-5 inline-flex items-center gap-1 text-[#B8956A] text-xs border-b border-[#B8956A] pb-0.5 cursor-pointer hover:text-[#A07B55] whitespace-nowrap" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
                    指名予約する
                    <span className="w-3 h-3 flex items-center justify-center"><i className="ri-arrow-right-line text-xs" /></span>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-24 bg-[#FAF8F6]">
        <div className="max-w-3xl mx-auto px-6 lg:px-10">
          <div className="text-center mb-12">
            <p className="text-[#B8956A] text-xs tracking-[0.3em] uppercase mb-3" style={{ fontFamily: "'Noto Serif JP', serif" }}>FAQ</p>
            <h2 className="text-3xl text-[#3D2E2A]" style={{ fontFamily: "'Noto Serif JP', serif", fontWeight: 300 }}>よくある質問</h2>
          </div>
          <div className="space-y-4">
            {faqs.map(({ q, a }) => (
              <div key={q} className="bg-white border border-[#EDE7DF] rounded-xl p-6">
                <div className="flex items-start gap-3 mb-3">
                  <span className="text-[#B8956A] font-medium text-sm shrink-0" style={{ fontFamily: "'Noto Serif JP', serif" }}>Q.</span>
                  <p className="text-[#3D2E2A] text-sm font-medium" style={{ fontFamily: "'Noto Serif JP', serif" }}>{q}</p>
                </div>
                <div className="flex items-start gap-3">
                  <span className="text-[#8B7355] font-medium text-sm shrink-0" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>A.</span>
                  <p className="text-[#6B5548] text-sm leading-relaxed" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>{a}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
